import axios from '../request/http';
import {toFormData} from '../common/descriptions'

const production = {
    // 商品管理列表
    listAll(params) {
        return axios.get("/admin/category/listAll", {params});
    },
    // 商品管理新增 || 编辑
    listAddEdit(data) {
        return axios.post("/admin/category/edit", data);
    },
    // 商品管理删除
    listDelete(params) {
        return axios.get("/admin/category/del", {params});
    },
    // 商品列表
    goodList(params) {
        return axios.get("/admin/goods/list", {params});
    },
    // 商品列表
    merchantGoodList(params) {
        return axios.get("/admin/Shop/getGoodsListByShopId", {params});
    },
      // 商品退款
      merchantGoodRefund(params) {
        return axios.get("/admin/order-management/goods/after-list/accept", {params});
    },
    // 上下架
    shelves(params) {
        return axios.get("/admin/goods/update/status", {params});
    },
    // 推荐
    goodsReco(params) {
        return axios.get("/admin/goods/update/reco", {params});
    },
    // 商品删除
    goodsDel(params) {
        return axios.get("/admin/goods/delete", {params});
    },
    // 商品信息添加
    goodsAdd(data) {
        return axios.post("/admin/goods/add", data);
    },
    // 商户商品信息添加
    merchantGoodsAdd(data) {
        return axios.post("/admin/goods/bus-goods/add", data);
    },
    // 商品规格新增
    specAdd(data) {
        return axios.post("/admin/goods/spec/add", data);
    },
    // 商品规格详情
    specDetail(params) {
        return axios.get("/admin/goods/detail", {params});
    },
    // 商品列表导出
    // ’arraybuffer‘返回的是包含二进制数据的JavaScriptArraybuffer。
    // responseType: 'arraybuffer' || blob
    productFile(params) {
        return axios.get("/admin/orderGoods/list/download", {params,responseType:'arraybuffer'});
    },
    // 服务订单导出
    serveFile(params) {
        return axios.get("/admin/order-management/list/download", {params,responseType: 'arraybuffer'});
    },
    // 商品导入
    putFile(data) {
        return axios.post("/admin/orderGoods/excel2List", data);
    },
    // 模板
    downTemplate(data) {
        return axios.post("/admin/orderGoods/downloadModel", data);
    },
    // 商品库
    goodsThirdList(params) {
        return axios.get("/admin/goods/third/list", {params});
    },
    // 加入店铺
    addSelection(params) {
        return axios.get("/admin/goods/business/choose", {params});
    },
    // 选品商品上下架
    businessUpdate(params) {
        return axios.get("/admin/goods/business/update", {params});
    },
    // 选品商品列表
    businessList(params) {
        return axios.get("/admin/goods/business/list", {params});
    },
    //添加活动商品库
    activityModuleAddlist(params) {
        return axios.get("/admin/activity-module/addlist", {params});
    },
    // 商户自营商品列表
    busselfList(params) {
        return axios.get("/admin/goods/bus-self/list",{params});
    },
    // 商户商品选品库
    busselfListCopy(params){
        return axios.get("/admin/goods/busGoodsSelectable",{params});
    },
    // 商户商品新增
    busselfListAdd(data){
        return axios.post("/admin/goods/busAdd/bus_goods",toFormData(data))
    }
}

export default production;


// WEBPACK FOOTER //
// ./src/api/production.js